import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import DatePicker from 'react-datepicker2';

export default class Request extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            pic: '',
            picFileName: ''
        }; 
    }
    setProfilePic(_file) {
        this.getBase64(_file).then(file => {
            this.state.pic = file;
            this.state.picFileName = _file.name;
        });
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/request/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/request/save", {
            id: this.state.id,
            name: this.state.data.record.name,
            mobile: this.state.data.record.mobile,
            stuffTypeId: this.state.data.record.stuffTypeId,    
            pic: this.state.pic,
            picFileName: this.state.picFileName,
            description: this.state.data.record.description,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                    {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات درخواست" : "افزودن درخواست جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نام و نام خانوادگی</label>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">شماره تماس</label>
                                            <input defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع کالا</label>
                                            <select defaultValue={this.state.data.record.stuffTypeId} onChange={e => this.state.data.record.stuffTypeId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.constants.map(r =>
                                                    r.type === 7 && <option value={r.id}>{r.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">فایل تصویر</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>
                                    {!this.isBlank(this.state.data.record.pic) && <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">تصویر فعلی</label>
                                            <div className="form-control-wrap">
                                                <a href={"/media/" + this.state.data.record.pic } target="_blank">مشاهده فایل</a>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <textarea defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100"></textarea>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}